// extracted by mini-css-extract-plugin
export default {"gridContainer":"gridProducts_gridContainer__0smTj","product":"gridProducts_product__3jbHt","image":"gridProducts_image__+E1Wc","txt":"gridProducts_txt__+0QoW"};